import React from "react";
import { Box } from "@mui/material";

export const DocumentWorkspace = ({ focused = false, children }) => (
  <Box
    sx={{
      bgcolor: "background.paper",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: focused ? 0 : 2,
      boxShadow: focused ? 8 : 1,
      overflow: "hidden",
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
    }}
  >
    {children}
  </Box>
);
